import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { UnicodeEntity } from '@mews/enums';
import { ApplicationState, OrderItem } from '@mews-commander/types';
import { ConvertedCurrencyValue, LocalizedShortDateFromUtc } from '@mews-commander/ui';
import { SimpleListItem } from '@optimus-web/core';
import { isCurrentEnterpriseInMultiTaxEnvironment } from '@mews-commander/legacy-entities/src/selectors/session/enterprise';
import { additionalExpensesHandler } from '../../additionalExpensesHandler';

interface OwnProps {
    additionalExpense: OrderItem;
    serviceId: string;
}
interface StateProps {
    isMultiTaxEnvironment: boolean;
}
type Props = StateProps & OwnProps;

const ExpenseDate = ({ startUtc }: { startUtc: string }) => (
    <>
        <LocalizedShortDateFromUtc utcString={startUtc} />
        {UnicodeEntity.Colon}
        {UnicodeEntity.NoBreakSpace}
    </>
);

const AdditionalExpensesListItem = ({
    additionalExpense: { startUtc, totalAmount, data },
    isMultiTaxEnvironment,
    serviceId,
}: Props) => (
    <SimpleListItem>
        {startUtc ? <ExpenseDate startUtc={startUtc} /> : null}
        <ConvertedCurrencyValue amount={totalAmount} net={isMultiTaxEnvironment} />
        {UnicodeEntity.NoBreakSpace}
        {UnicodeEntity.LeftParenthesis}
        {additionalExpensesHandler(data.discriminator, { serviceId })}
        {UnicodeEntity.RightParenthesis}
    </SimpleListItem>
);

export default connect<StateProps, {}, OwnProps, ApplicationState>(
    createStructuredSelector({
        isMultiTaxEnvironment: (state: ApplicationState) => isCurrentEnterpriseInMultiTaxEnvironment(state),
    })
)(AdditionalExpensesListItem);
